import React from "react";
import Header from "../../components/HeaderNew";
import { Button } from "@material-ui/core";
import Footer from "../FooterNew";

import { Helmet } from "react-helmet";
import Slider from "react-slick";

import { Section } from "react-scroll-section";
import NewHead from "../landing/NewHead";
import ServiceFooter from "../ServiceFooter";

function Cex() {
  const processes_newew = {
    arrows: false,
    dots: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
          arrow: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },

      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
          autoplay: true,
          arrow: false,
          autoplaySpeed: 2000,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          arrow: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },
    ],
  };
  return (
    <div className="newpage blog_page OTC_SR">
      <header>
        {/* <Header /> */}
        <NewHead />
      </header>
      <div className="paddin_immner">
        <main className=" carer_page">
          <span>
            <Helmet>
              <title>
                OTC Exchange Platform Development Company - Beleaf Technology
              </title>
              <link
                rel="canonical"
                href="https://beleaftechnologies.com/crypto-otc-trading-platform-development"
              />
              <meta
                name="title"
                content="OTC Exchange Platform Development Company - Beleaf Technology 
                "
              />
              <meta
                name="description"
                content="As a leading OTC exchange development company, Beleaf Technolgy offer an unconquerable and huge amount of much needed OTC exchange platform development services that build your own business for the protection of every transaction and to create a highly efficient workflow."
              />
              <meta
                name="keywords"
                content="Crypto OTC Trading Platform Company,Crypto OTC Trading Platform,Crypto OTC Trading Platform Development,OTC Trading Platform Development, White Label OTC Exchange Development Company"
              />
            </Helmet>
            <div className="ourserveic_banner OTC_Bnner_section">
              <div className="bg-overlay"></div>
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="service_content otc_secvice_content">
                      <h1 className="text-center">
                        OTC Crypto Trading Software Development
                      </h1>
                      <p className="text-center mb-4">
                        Count on our experts to turn your OTC Crypto Trading
                        platform idea into a million-dollar reality!
                      </p>
                      <Button
                        data-toggle="modal"
                        data-target="#myModal"
                        aria-label=" Get Free Consultation"
                        className="m-auto d-block"
                      >
                        Get Free Consultation
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <section className="section bg-white">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <img
                      src={require("../../image/otc/pexels-anna-nekrashevich.webp")}
                      alt="Smart Contract Auditing Service Company"
                      className="image_radious"
                    />
                  </div>
                  <div className="col-lg-6 d-flex align-items-center">
                    <div className="first_section_crypto">
                      <h2 className="">
                        What is an OTC Cryptocurrency Exchange?
                      </h2>
                      <p className="OTC_p">
                        Consider the foreign exchange market, where you may
                        trade different currencies. You may have heard it
                        referred to as Forex, FX, or the currency market. Forex
                        is by far the greatest market in the world in terms of
                        trading volume, and millions of individuals trade on it
                        every day.
                        <br />
                        An OTC Cryptocurrency exchange is the same thing, except
                        with, you guessed it, cryptocurrency.
                      </p>
                      <Button
                        data-toggle="modal"
                        data-target="#myModal"
                        aria-label="Get Started"
                      >
                        Get Started
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white pt-0">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="first_section_crypto">
                      <h2 className="text-center text_center_new">
                        OTC Exchange Platform Development
                      </h2>
                      <p className="text-center mb-5">
                        We've been offering top-notch software solutions to
                        companies all around the world for years, and we knew
                        the future belonged to blockchain and cryptocurrencies
                        long before anybody else. That is why we decided to
                        establish ourselves as an OTC exchange development firm
                        and began developing our own OTC trading software.
                        Beleaf's OTC trading software is the ideal answer for
                        crypto start-ups wishing to build such a platform, and
                        it is the only one of its type.
                      </p>

                      <Button
                        data-toggle="modal"
                        data-target="#myModal"
                        aria-label=" Schedule A Call"
                        className="m-auto d-block"
                      >
                        Schedule A Call
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white pt-0">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="dex_third_conetnt">
                      <h2 className="mb-2">
                        Beleaf specializes in the development of Crypto OTC
                        trading platforms
                      </h2>
                      <p className="text-center mb-5">
                        Our developers put everything into the OTC exchange
                        platform so that you and your users have the finest
                        trading experience possible. We are quite knowledgeable
                        about
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="futerr_conete new_our_furtur inner_card_height_none grid_ful_height_tab">
                      <div className="row">
                        <div className="col-md-6 col-lg-6 d-flex">
                          <div className="feure_item heing_new_card OTC_card_p">
                            <div>
                              <h4>White Label Crypto OTC Trading Software</h4>
                              <p>
                                Beleaf is a worldwide recognised crypto OTC
                                trading platform firm and a leading provider of
                                White Label Crypto OTC Trading Software
                                solutions. Our cutting-edge crypto exchange
                                software supports a variety of digital coins,
                                including Bitcoin, Ethereum, Litecoin, and
                                others.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6 d-flex">
                          <div className="feure_item heing_new_card OTC_card_p">
                            <div>
                              <h4>Custom Crypto OTC Trading Development</h4>
                              <p>
                                Beleaf can assist you in creating a bespoke OTC
                                trading platform. We provide tailored solutions
                                for developing high-performance crypto exchange
                                systems. We effectively respond to your demands
                                whether you want a solution from scratch or
                                white-label.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white pt-0">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-12">
                    <div className="first_section_crypto">
                      <h2 className="text_ceeenter">
                        Our OTC Trading Platform Development Services
                      </h2>
                    </div>
                  </div>

                  <div className="col-md-6 col-lg-4 defi-staking_section">
                    <div className="card_DEFI">
                      <span>01</span>
                      <h3>Storage of Data</h3>
                      <p>
                        Our software can handle and process enormous amounts of
                        bitcoin market data and present it to you with a single
                        click.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4 defi-staking_section">
                    <div className="card_DEFI">
                      <span>02</span>
                      <h3>Trading Algorithms</h3>
                      <p>
                        Our cutting-edge trading algorithms give customers a
                        step-by-step set of instructions that make buying and
                        selling orders straightforward.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4 defi-staking_section">
                    <div className="card_DEFI">
                      <span>03</span>
                      <h3>Connectors Exchange</h3>
                      <p>
                        If you already have a crypto exchange platform and want
                        to shift to a more stable server, we are the ideal
                        alternative for you.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4 defi-staking_section">
                    <div className="card_DEFI">
                      <span>04</span>
                      <h3>Exchange System</h3>
                      <p>
                        Our skilled developers focus on designing user-friendly
                        exchange systems with cutting-edge features.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4 defi-staking_section">
                    <div className="card_DEFI">
                      <span>05</span>
                      <h3>Trade Execution</h3>
                      <p>
                        Because of the integration of low-legacy trading
                        software that provides the quickest transactions and
                        token transfers, everything is done at lightning speed.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4 defi-staking_section">
                    <div className="card_DEFI">
                      <span>06</span>
                      <h3>Investor Frontends</h3>
                      <p>
                        Our aesthetically appealing design for your mobile,
                        internet, or software solution is adequate to attract
                        new customers and maintain existing ones.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg_white padeing_top_2 pt-0">
              <div className="container">
                <div className="col-lg-12">
                  <div className="section_sub_heading mb-4">
                    <div className="whybelaf faq">
                      <h2 data="" className="text-center">
                        Our OTC Crypto Exchange Platform's Advantages
                      </h2>
                    </div>
                    <h3 className="text-center">
                      OTC was developed by professional Blockchain Developers in
                      order to deliver a seamless and safe Crypto trading
                      experience.
                    </h3>
                  </div>
                </div>
                <div className="row justify-content-center otc_row">
                  <div className="col-md-6 col-lg-4">
                    <div className="card_icon_" data="1">
                      <img
                        src={require("../../image/otc/cryptocurrencies.webp")}
                        alt="Smart Contract Auditing Service Company"
                        className="image_radious"
                      />
                      <p>
                        Multi Cryptocurrency
                        <br /> Wallet
                      </p>
                      <span>
                        For any cryptocurrency exchange to be successful, users
                        must have the finest trading options available. Our OTC
                        trading platform offers a multi-crypto wallet.
                      </span>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="card_icon_" data="2">
                      <img
                        src={require("../../image/otc/user-experience.webp")}
                        alt="Smart Contract Auditing Service Company"
                        className=""
                      />
                      <p>UI/UX Design</p>
                      <span>
                        Our OTC exchange platform development designers have
                        proved their creative skills by building an eye-catching
                        user interface.
                      </span>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="card_icon_" data="3">
                      <img
                        src={require("../../image/otc/shield.webp")}
                        alt="Smart Contract Auditing Service Company"
                        className=""
                      />
                      <p>
                        Safe and Secure
                        <br /> Transaction
                      </p>
                      <span>
                        When it comes to financial transactions, our OTC trading
                        software delivers unparalleled security. Furthermore,
                        because it is built on the blockchain, all transactions
                        are easily traceable.
                      </span>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="card_icon_" data="4">
                      <img
                        src={require("../../image/otc/search.webp")}
                        alt="Smart Contract Auditing Service Company"
                        className=""
                      />
                      <p>KYC Verification</p>
                      <span>
                        Scammers are common in the cryptosphere. KYC
                        verification on our OTC trading platform completely
                        solves this problem.
                      </span>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="d-flex respozrfve_nuttn justify-content-center mt-4">
                      <div className="button_why_devee">
                        <a
                          href="https://wa.me/7904323274"
                          target="_blank"
                          className="m-0 mr-2"
                        >
                          Connect Whatsapp
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-light">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="dex_third_conetnt">
                      <h2 className="mb-3">
                        Key Features of an OTC Exchange Platform
                      </h2>
                      <p className="text-center mb-5">
                        Choosing an OTC exchange platform may provide the
                        following benefits
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="futerr_conete card_P2P_new keyfetures">
                      <div className="row justify-content-center">
                        <div className="col-md-6 col-lg-4">
                          <div className="feure_item">
                            <div className="p2pimg_section">
                              {" "}
                              <img
                                src={require("../../image/otc_platform/grow.webp")}
                                alt="techstack"
                              />
                            </div>
                            <h4>Scalability</h4>
                            <p>
                              OTC’s Scalability in nature is due to its modular
                              architecture, which is highly scalable to handle
                              various cryptocurrencies, simple API layer
                              interface with third parties, customizable
                              individual features, frequent upgrades, and so on.
                            </p>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                          <div className="feure_item">
                            <div className="p2pimg_section">
                              {" "}
                              <img
                                src={require("../../image/otc_platform/accountability.webp")}
                                alt="techstack"
                              />
                            </div>
                            <h4>Ease of doing business</h4>
                            <p>
                              With its multiple benefits, such as automated IP
                              identification to display local crypto
                              advertisements, know your customer (KYC) users,
                              tracing money, transaction reports, MIS reports,
                              and so on, the OTC exchange platform makes
                              business easier.
                            </p>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                          <div className="feure_item">
                            <div className="p2pimg_section">
                              {" "}
                              <img
                                src={require("../../image/otc_platform/smartphone.webp")}
                                alt="techstack"
                              />
                            </div>
                            <h4>Usability</h4>
                            <p>
                              The usability comes with responsive and clean user
                              interface with intuitive dashboard, market depth
                              chart and trade charts, user pleasant navigation
                              and trading procedure, and unique themes created
                              by UI/UX specialists.
                            </p>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                          <div className="feure_item">
                            <div className="p2pimg_section">
                              {" "}
                              <img
                                src={require("../../image/otc_platform/cyber-security.webp")}
                                alt="techstack"
                              />
                            </div>
                            <h4>Security</h4>
                            <p>
                              For enhanced protection, the OTC exchange platform
                              offers safe transactions, two factor
                              authentication, provisional wallet automation,
                              dedicated wallet, and a decentralized ledger.
                            </p>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                          <div className="feure_item">
                            <div className="p2pimg_section">
                              {" "}
                              <img
                                src={require("../../image/otc_platform/settings.webp")}
                                alt="techstack"
                              />
                            </div>
                            <h4>Configurable</h4>
                            <p>
                              It is extensively customizable in order to take
                              use of its incredible benefits. It includes
                              granular user access control, a management
                              dashboard for managing platforms, the supply of
                              numerous cryptocurrencies, and the configuration
                              and usage of commission using smart contracts.
                            </p>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                          <div className="feure_item">
                            <div className="p2pimg_section">
                              {" "}
                              <img
                                src={require("../../image/otc_platform/easy.webp")}
                                alt="techstack"
                              />
                            </div>
                            <h4>Easy to Use Mining</h4>
                            <p>
                              The easiest aspect of stablecoin development is
                              user-friendly mining. Cloud mining ensures that
                              miners do not need sophisticated equipment to mine
                              gold-backed or currency-backed cryptos.
                            </p>
                          </div>
                        </div>

                        <div className="col-lg-12 first_section_crypto">
                          <Button
                            data-toggle="modal"
                            data-target="#myModal"
                            aria-label="Contact US"
                            className="m-auto mt-4 margin_top_p"
                          >
                            Contact US
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <img
                      src={require("../../image/otc/pexels-cottonbro.webp")}
                      alt="Smart Contract Auditing Service Company"
                      className="image_radious"
                    />
                  </div>
                  <div className="col-lg-6">
                    <div className="first_section_crypto">
                      <h2 className="">
                        Our OTC cryptocurrency exchange platform's security
                        features
                      </h2>
                      <p className="">
                        Beleaf Technology consistently prioritizes security
                        aspects. We use strong security elements to provide a
                        very secure OTC crypto exchange platform.
                      </p>
                      <ul className="list_item_sec">
                        <li>
                          <span>
                            {" "}
                            <i className="bi bi-patch-check-fill"></i>
                          </span>{" "}
                          SSL Protection
                        </li>
                        <li>
                          <span>
                            {" "}
                            <i className="bi bi-patch-check-fill"></i>
                          </span>{" "}
                          End-To-End Encryption
                        </li>
                        <li>
                          <span>
                            {" "}
                            <i className="bi bi-patch-check-fill"></i>
                          </span>{" "}
                          Multi Layered Authentication
                        </li>
                        <li>
                          <span>
                            {" "}
                            <i className="bi bi-patch-check-fill"></i>
                          </span>{" "}
                          Secure API Connections
                        </li>
                        <li>
                          <span>
                            {" "}
                            <i className="bi bi-patch-check-fill"></i>
                          </span>{" "}
                          Device-Enabled Security
                        </li>
                        <li>
                          <span>
                            {" "}
                            <i className="bi bi-patch-check-fill"></i>
                          </span>{" "}
                          Indisputable Tokens
                        </li>
                        <li>
                          <span>
                            {" "}
                            <i className="bi bi-patch-check-fill"></i>
                          </span>{" "}
                          Optional KYC Integration
                        </li>
                      </ul>
                      {/* <Button data-toggle="modal" data-target="#myModal">
                        Let’s Discuss
                      </Button> */}
                      <div className="d-flex justify-content-center respozrfve_nuttn">
                        <div className="button_why_devee">
                          <a
                            href="https://wa.me/7904323274"
                            target="_blank"
                            className="m-0 mr-2"
                          >
                            Connect Whatsapp
                          </a>
                        </div>
                        <div className="button_why_devee">
                          {/* <a
                            href="https://join.skype.com/invite/wg5IW8g4Uaca"
                            target="_blank"
                            className="m-0"
                          >
                            Connect Skype
                          </a> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white pt-0">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="dex_third_conetnt">
                      <h2 className="mb-2">
                        OTC Crypto Exchange Development Process
                      </h2>
                      <p className="text-center mb-5">
                        Beleaf follows several basic methods for developing and
                        deploying an OTC cryptocurrency exchange platform.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="futerr_conete new_our_furtur inner_card_height_none grid_ful_height_tab">
                      <div className="row">
                        <div className="col-md-6 col-lg-6 d-flex">
                          <div className="feure_item heing_new_card">
                            <div className="imag_card_section card_pic">
                              <img
                                src={require("../../image/otc/inspection.webp")}
                                alt="Smart Contract Auditing Service Company"
                                className="d-block mx-auto"
                              />
                            </div>
                            <div>
                              <h4>Gathering of requirements</h4>
                              <p>
                                In the beginning, we would gather customer
                                requirements and compare them to the present
                                crypto market. Following the investigation, we
                                will present the best option for beginning an
                                OTC crypto exchange firm.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6 d-flex">
                          <div className="feure_item heing_new_card">
                            <div className="imag_card_section card_pic">
                              <img
                                src={require("../../image/otc/planning_rbsxgp.webp")}
                                alt="Smart Contract Auditing Service Company"
                                className="d-block mx-auto"
                              />
                            </div>
                            <div>
                              <h4>Planning</h4>
                              <p>
                                Based on the clients' business requirements, our
                                specialists will build a preliminary strategy
                                for the construction of an OTC crypto exchange.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6 d-flex">
                          <div className="feure_item heing_new_card">
                            <div className="imag_card_section card_pic">
                              <img
                                src={require("../../image/otc/sketch_phyyh0.webp")}
                                alt="Smart Contract Auditing Service Company"
                                className="d-block mx-auto"
                              />
                            </div>
                            <div>
                              <h4>Designing</h4>
                              <p>
                                After validation from both the client-side and
                                the designer team, any design that is
                                implemented in the OTC exchange will be
                                transferred to the next level.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6 d-flex">
                          <div className="feure_item heing_new_card">
                            <div className="imag_card_section card_pic">
                              <img
                                src={require("../../image/otc/coding_uw8adx.webp")}
                                alt="Smart Contract Auditing Service Company"
                                className="d-block mx-auto"
                              />
                            </div>
                            <div>
                              <h4>Development</h4>
                              <p>
                                At this stage, we would construct and modify the
                                complete cryptocurrency exchange to meet the
                                demands of the customer.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6 d-flex">
                          <div className="feure_item heing_new_card">
                            <div className="imag_card_section card_pic">
                              <img
                                src={require("../../image/otc/test_uxwdnh.webp")}
                                alt="Smart Contract Auditing Service Company"
                                className="d-block mx-auto"
                              />
                            </div>
                            <div>
                              <h4>Testing</h4>
                              <p>
                                Following the development stage, our testing
                                team will run numerous tests to assess the
                                quality of the OTC crypto exchange. If any
                                functionality fails to operate properly, our
                                staff will resolve the problem as soon as
                                possible.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6 d-flex">
                          <div className="feure_item heing_new_card">
                            <div className="imag_card_section card_pic">
                              <img
                                src={require("../../image/otc/startup8.webp")}
                                alt="Smart Contract Auditing Service Company"
                                className="d-block mx-auto"
                              />
                            </div>
                            <div>
                              <h4>Deployment</h4>
                              <p>
                                Our development team will deliver the superfine
                                OTC crypto exchange on the server per the
                                client's requirement.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <Section id="Process">
              <section className="bg-progress section our_process new_testiomial bg-white pt-0 clone_eeeeeee">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="dex_third_conetnt">
                        <h2 className="mb-3">
                          Our OTC Crypto Exchange's Technology Stack
                        </h2>
                        <p className="text-center">
                          Beleaf employs a suite of innovative technologies in
                          the development and deployment of error-free OTC
                          bitcoin trading software.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <Slider {...processes_newew}>
                    <div className="logo_clinet_img">
                      <img
                        src={require("../../image/otc/GitHub-logo.webp")}
                        alt="techstack"
                      />
                    </div>
                    <div className="logo_clinet_img">
                      <img
                        src={require("../../image/otc/node.js.webp")}
                        alt="techstack"
                      />
                    </div>
                    <div className="logo_clinet_img">
                      <img
                        src={require("../../image/otc/AngularJS.webp")}
                        alt="techstack"
                      />
                    </div>
                    <div className="logo_clinet_img">
                      <img
                        src={require("../../image/otc/React_logo.webp")}
                        alt="techstack"
                      />
                    </div>
                    <div className="logo_clinet_img">
                      <img
                        src={require("../../image/otc/MongoDB_Logo.webp")}
                        alt="techstack"
                      />
                    </div>
                  </Slider>
                </div>
              </section>
            </Section>
            <section className="section bg-white">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="first_section_crypto">
                      <h2 className="">Crypto coins used in OTC trading</h2>
                      <p className="">
                        We are skilled in integrating the following coins, as
                        well as any other cryptocurrency of your choice.
                      </p>
                      <ul className="list_item_sec">
                        <li>
                          {" "}
                          <span>
                            {" "}
                            <i className="bi bi-patch-check-fill"></i>
                          </span>{" "}
                          Ethereum Coin
                        </li>
                        <li>
                          <span>
                            {" "}
                            <i className="bi bi-patch-check-fill"></i>
                          </span>{" "}
                          Bitcoin Cash
                        </li>
                        <li>
                          <span>
                            {" "}
                            <i className="bi bi-patch-check-fill"></i>
                          </span>{" "}
                          PrimeCoin
                        </li>
                        <li>
                          <span>
                            {" "}
                            <i className="bi bi-patch-check-fill"></i>
                          </span>{" "}
                          NXT
                        </li>
                        <li>
                          <span>
                            {" "}
                            <i className="bi bi-patch-check-fill"></i>
                          </span>{" "}
                          Dash
                        </li>
                        <li>
                          <span>
                            {" "}
                            <i className="bi bi-patch-check-fill"></i>
                          </span>{" "}
                          Bitcoin
                        </li>
                        <li>
                          <span>
                            {" "}
                            <i className="bi bi-patch-check-fill"></i>
                          </span>{" "}
                          Feathercoin
                        </li>
                        <li>
                          <span>
                            {" "}
                            <i className="bi bi-patch-check-fill"></i>
                          </span>{" "}
                          Litecoin
                        </li>
                      </ul>
                      {/* <Button data-toggle="modal" data-target="#myModal">
                        Let’s Discuss
                      </Button> */}
                      <div className="d-flex respozrfve_nuttn">
                        {/* <div className="button_why_devee">
                          <a
                            href=" https://wa.me/8056786622"
                            target="_blank"
                            className="m-0 mr-2"
                          >
                            Connect Whatsapp
                          </a>
                        </div> */}
                        <div className="button_why_devee">
                          {/* <a
                            href="https://join.skype.com/invite/wg5IW8g4Uaca"
                            target="_blank"
                            className="m-0"
                          >
                            Connect Skype
                          </a> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <img
                      src={require("../../image/otc/pexels-alesia.webp")}
                      alt="Smart Contract Auditing Service Company"
                      className="image_radious"
                    />
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white pt-0">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-12">
                    <div className="first_section_crypto">
                      <h2 className="text_ceeenter">
                        Why should you use Beleaf Technology to create an OTC
                        Exchange platform?
                      </h2>
                      <p className="text-center mb-5">
                        Our OTC cryptocurrency exchange building service is the
                        best and most professional in the crypto business. We
                        provide a single package containing everything you need
                        to create an amazing OTC cryptocurrency trading
                        platform.
                      </p>
                    </div>
                  </div>

                  <div className="col-md-6 col-lg-4">
                    <div className="card_white OTC_card_white_new">
                      <img
                        src={require("../../image/otc/coding_pror1h.webp")}
                        alt="Smart Contract Auditing Service Company"
                        className=""
                      />
                      <h3>Dedicated Blockchain Developers</h3>
                      <p>
                        Our development team has extensive hands-on expertise
                        working on several blockchain projects.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="card_white OTC_card_white_new">
                      <img
                        src={require("../../image/otc/360_i9p4o8.webp")}
                        alt="Smart Contract Auditing Service Company"
                        className=""
                      />
                      <h3>360-Degree Assistance</h3>
                      <p>
                        From design to development to deployment to marketing,
                        we can offer you comprehensive help to ensure the
                        success of your OTC crypto exchange.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="card_white OTC_card_white_new">
                      <img
                        src={require("../../image/otc/surprised_yot0mq.webp")}
                        alt="Smart Contract Auditing Service Company"
                        className=""
                      />
                      <h3>No Unpleasant Surprises</h3>
                      <p>
                        When you collaborate with us, you will never be
                        surprised by rising prices or looming deadlines.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="card_white OTC_card_white_new">
                      <img
                        src={require("../../image/otc/goal_mulo2i.webp")}
                        alt="Smart Contract Auditing Service Company"
                        className=""
                      />
                      <h3>Scalable Growth</h3>
                      <p>
                        Whatever your budget is, and whatever features and
                        capabilities you wish to include, we can scale
                        accordingly.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="card_white OTC_card_white_new">
                      <img
                        src={require("../../image/otc/responsive_i7enz6.webp")}
                        alt="Smart Contract Auditing Service Company"
                        className=""
                      />
                      <h3>Multiplatform</h3>
                      <p>
                        Your users will be able to access your OTC crypto
                        exchange platform from a variety of devices running
                        various operating systems.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="card_white OTC_card_white_new">
                      <img
                        src={require("../../image/otc_platform/label.webp")}
                        alt="Smart Contract Auditing Service Company"
                        className=""
                      />
                      <h3>Whitelabel Platform</h3>
                      <p>
                        We will provide you with a totally customisable OTC
                        crypto exchange platform that you may modify in any way
                        you see fit.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <Section id="about why new_faq bg_white CEX_faq">
              <section className="section bg_white CEX_faq" id="">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6 d-flex justify-content-center  align-items-center">
                      <div className="whybelaf faq">
                        <h2 className="">
                          Frequently asked <br />
                          Question
                        </h2>
                        <p></p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="comtent">
                        <div id="main">
                          <div className="container">
                            <div className="accordion" id="faq">
                              <div className="card">
                                <div className="card-header" id="faqhead1">
                                  <a
                                    href="#"
                                    className="btn btn-header-link"
                                    data-toggle="collapse"
                                    data-target="#faq1"
                                    aria-expanded="true"
                                    aria-controls="faq1"
                                  >
                                    What distinguishes an OTC crypto exchange
                                    from a traditional exchange?
                                  </a>
                                </div>

                                <div
                                  id="faq1"
                                  className="collapse show"
                                  aria-labelledby="faqhead1"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    Users do not actively purchase and sell
                                    cryptocurrency on a typical crypto exchange.
                                    They do this through a trade. Your users may
                                    purchase and sell straight from one other on
                                    an OTC crypto market.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead2">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq2"
                                    aria-expanded="true"
                                    aria-controls="faq2"
                                  >
                                    Will my OTC crypto exchange allow consumers
                                    to sell all cryptocurrencies?
                                  </a>
                                </div>

                                <div
                                  id="faq2"
                                  className="collapse"
                                  aria-labelledby="faqhead2"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    Yes, they will be able to sell and purchase
                                    all current and significant
                                    cryptocurrencies.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead3">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq3"
                                    aria-expanded="true"
                                    aria-controls="faq3"
                                  >
                                    How does over-the-counter cryptocurrency
                                    trading work?
                                  </a>
                                </div>

                                <div
                                  id="faq3"
                                  className="collapse"
                                  aria-labelledby="faqhead3"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    OTC crypto trading platforms function by
                                    facilitating rapid and simple crypto
                                    transactions between buyers and sellers.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead4">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq4"
                                    aria-expanded="true"
                                    aria-controls="faq4"
                                  >
                                    Is it expensive to construct an OTC
                                    cryptocurrency exchange platform?
                                  </a>
                                </div>

                                <div
                                  id="faq4"
                                  className="collapse"
                                  aria-labelledby="faqhead4"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    It is less expensive than the typical route.
                                    We have the majority of the scripts ready.
                                    We have numerous platforms on hand that we
                                    can instal in the shortest amount of time.
                                    We already have fantastic libraries that we
                                    have built through hard effort. Nonetheless,
                                    the ultimate rate is determined by the size
                                    of your cryptocurrency trading platform.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead5">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq5"
                                    aria-expanded="true"
                                    aria-controls="faq5"
                                  >
                                    Which cryptocurrencies may be traded on an
                                    over-the-counter trading platform?
                                  </a>
                                </div>

                                <div
                                  id="faq5"
                                  className="collapse"
                                  aria-labelledby="faqhead5"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    On an OTC trading platform, you may swap all
                                    types of cryptocurrencies, or you can choose
                                    your preferences based on your needs.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </Section>
          </span>
          {/* <Commonpage /> */}
        </main>
      </div>

      {/* <Footer /> */}
      <ServiceFooter />
    </div>
  );
}

export default Cex;
